import _Vue from "vue"; // <-- notice the changed import
import translations, { Translations } from "@/utils/Translations";
import { Config } from "@/settings/Config";
import { ValidityHelper } from "@/utils/ValidityHelper";
import { Tracker } from "@/utils/Tracker";

export function Plugins(Vue: typeof _Vue): void {
  Vue.prototype.$t = translations;
  Vue.prototype.$config = new Config();
  Vue.prototype.$validityHelper = new ValidityHelper();
  Vue.prototype.$tracker = new Tracker();
}

declare module "vue/types/vue" {
  interface Vue {
    $t: Translations;
    $config: Config;
    $validityHelper: ValidityHelper;
    $tracker: Tracker;
  }
}
